import { ColProps, Form, Input } from "antd";
import { Rule } from "antd/es/form";
import { FormLabelAlign, NamePath } from "antd/es/form/interface";
import React from "react";
export interface ShowCountProps {
  formatter: (args: {
    value: string;
    count: number;
    maxLength?: number;
  }) => React.ReactNode;
}
type Props = {
  className?: string;
  hidden?: boolean;
  label?: React.ReactNode;
  hasFeedback?: boolean | undefined;
  getValueProps?: ((value: any) => Record<string, unknown>) | undefined;
  initialValue?: any;
  labelCol?: ColProps | undefined;
  labelAlign?: FormLabelAlign | undefined;
  rules?: Rule[] | undefined;
  status?: "" | "success" | "warning" | "error" | "validating" | undefined;
  style?: React.CSSProperties | undefined;
  name?: string | undefined;
  readOnly?: boolean;
  type?: string;
  pattern?: string;
  title?: string;
  bordered?: boolean | undefined;
  styleInput?: React.CSSProperties | undefined;
  maxLength?: number | undefined;
  showCount?: boolean | ShowCountProps | undefined;
  inputMode?:
    | "none"
    | "url"
    | "search"
    | "text"
    | "email"
    | "tel"
    | "numeric"
    | "decimal"
    | undefined;
  placeholder?: string | undefined;
  addonAfter?: React.ReactNode;
  addonBefore?: React.ReactNode;
  allowClear?:
    | boolean
    | {
        clearIcon?: React.ReactNode;
      }
    | undefined;
};
const CommentInput = ({
  name,
  className,
  hidden,
  hasFeedback,
  getValueProps,
  initialValue,
  labelAlign,
  labelCol,
  label,
  rules,
  status,
  style,
  readOnly = false,
  type,
  pattern,
  title,
  bordered = false,
  styleInput = { borderBottom: "1px solid #898889", borderRadius: 0 },
  maxLength,
  showCount,
  inputMode,
  placeholder,
  addonAfter,
  addonBefore,
  allowClear,
}: Props) => {
  return (
    <Form.Item
      className={`${className} comment_input `}
      hidden={hidden}
      hasFeedback={hasFeedback}
      getValueProps={getValueProps}
      initialValue={initialValue}
      label={label}
      labelCol={labelCol}
      labelAlign={labelAlign}
      rules={rules}
      status={status}
      style={style}
      name={name}
    >
      <Input
        placeholder={placeholder}
        type={type}
        inputMode={inputMode}
        bordered={bordered}
        style={styleInput}
        readOnly={readOnly}
        pattern={pattern}
        title={title}
        maxLength={maxLength}
        showCount={showCount}
        addonAfter={addonAfter}
        addonBefore={addonBefore}
        allowClear={allowClear}
      />
    </Form.Item>
  );
};

export default CommentInput;
